export const LIST_POINT_LOGS = 'LIST_POINT_LOGS'; 
export const CHANGE_POINT = 'CHANGE_POINT';